import React from 'react'

import { TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

function EmailField({ value, onChange }) {
  return (
    <TextInput
      id="sign-in-email"
      type="primary"
      size="medium"
      label="Email"
      placeholder="john@email.com"
      value={value}
      onChange={onChange}
      wrapperClassName="auth-modal__field"
      aria-label="Email address"
      autoFocus
      isPilot
    />
  )
}

EmailField.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
}

export default EmailField
